<div id="alcmeon-to-crm-workflow">
  <div class="alc-margin-top-32 alc-margin-bottom-16">
    <h3 class="crm-sections-title" translate="crm/configuration/workflow-mappings/from-alc-to-sf"></h3>
    <a
      class="crm-doc-links"
      href=" https://developers.alcmeon.com/docs/sf-configuration-alcmeon#from-alcm%C3%A9on-to-salesforce"
      target="_blank">
      {{ 'crm/configuration/sync-conversation-doc' | translate }}
    </a>
  </div>
  <div class="alc-margin-left-32">
    <div
      *ngFor="let mappingControl of mappingsFromAlcmeonToSalesforceArray.controls; let i = index"
      class="mapping-control-line">
      <app-select
        [control]="mappingControl.get('team_tag_id')"
        [items]="routingTagsItems"
        labelKey="crm/configuration/workflow-mappings/from-alc-to-sf/condition">
      </app-select>
      <app-select
        [control]="mappingControl.get('queue_id')"
        [items]="availableSfQueues"
        labelKey="crm/configuration/workflow-mappings/from-alc-to-sf/action">
      </app-select>

      <button mat-icon-button (click)="deleteMappingFromAlcmeonToSalesforce(i)" color="warn">
        <mat-icon>delete</mat-icon>
      </button>
    </div>

    <div>
      <mat-icon
        [class.disabled]="mappingsFromAlcmeonToSalesforceArray.invalid"
        (click)="addMappingFromAlcmeonToSalesforce(mappingsFromAlcmeonToSalesforceArray)"
        color="primary">
        add_circle_outline
      </mat-icon>
    </div>
  </div>
</div>
<div id="crm-to-alcmeon-workflow">
  <div class="alc-margin-bottom-16">
    <h3 class="crm-sections-title" translate="crm/configuration/workflow-mappings/from-sf-to-alc"></h3>
    <a
      class="crm-doc-links"
      href="https://developers.alcmeon.com/docs/sf-configuration-alcmeon#from-salesforce-to-alcm%C3%A9on"
      target="_blank">
      {{ 'crm/configuration/sync-conversation-doc' | translate }}
    </a>
  </div>
  <div class="alc-margin-left-32">
    <div
      *ngFor="let mappingControl of mappingsFromSalesforceToAlcmeonArray.controls; let i = index"
      class="mapping-control-line">
      <app-select
        [control]="mappingControl.get('queue_id')"
        [items]="availableSfQueues"
        labelKey="crm/configuration/workflow-mappings/from-sf-to-alc/condition">
      </app-select>
      <app-select
        [control]="mappingControl.get('team_tag_id')"
        [items]="routingTagsItems"
        labelKey="crm/configuration/workflow-mappings/from-sf-to-alc/action">
      </app-select>

      <button mat-icon-button (click)="deleteMappingFromSalesforceToAlcmeon(i)" color="warn">
        <mat-icon>delete</mat-icon>
      </button>
    </div>

    <div>
      <mat-icon
        [class.disabled]="mappingsFromSalesforceToAlcmeonArray.invalid"
        (click)="addMappingFromSalesforceToAlcmeon(mappingsFromSalesforceToAlcmeonArray)"
        color="primary">
        add_circle_outline
      </mat-icon>
    </div>
  </div>
</div>
